import { IBangDiemSinhVienSelectRequest } from "../../model/request/in-bang-diem/IBangDiemSinhVienSelectRequest";
import { apiClient } from "../apiClient";

export const IN_BANG_DIEM_ENDPOINT = "diem/bang-diem-sinh-vien";
export const inBangDiemApi = {
    SelectBangDiemSinhVien: (request: IBangDiemSinhVienSelectRequest) => apiClient.post(IN_BANG_DIEM_ENDPOINT, request)
}